import { useLazyQuery } from '@apollo/client';
import { csvDownload } from '@openx/components-core/utils/csvDownload';
import { Order_By } from '@openx/types/gqlTypes';
import { useCallback } from 'react';
import { GetTaxonomyDownloadDocument } from '../../../graphql/query/taxonomy/GetTaxonomyDownload.generated';

import { VALID_TAXONOMY_CATEGORIES } from '../constants';

export const taxonomyHeaders = [
  { key: 'name', label: 'Segment' },
  { key: 'full_name', label: 'Segment Full Name' },
  { key: 'description', label: 'Segment Description' },
  { key: 'segment_sub_category', label: 'Segment Sub Category' },
  { key: 'segment_category', label: 'Segment Category' },
  { key: 'segment_type', label: 'Segment Type' },
  { key: 'segment_source', label: 'Segment Source' },
  { key: 'segment_source_description', label: 'Segment Source Description' },
];

const prepareTaxonomyDataToDownload = data => {
  return data.map(taxonomy => ({
    ...taxonomy,
    description: taxonomy.description.replace(/"/g, '""'),
  }));
};

interface TaxonomyDownloadResponse {
  taxonomyLoading: boolean;
  handleDownloading: () => void;
}

export const useTaxonomyDownload = (): TaxonomyDownloadResponse => {
  const [fetchTaxonomy, { loading: taxonomyLoading }] = useLazyQuery(GetTaxonomyDownloadDocument, {
    variables: {
      order_by: [
        { segment_type: Order_By.Asc },
        { segment_category: Order_By.Asc },
        { segment_sub_category: Order_By.Asc },
        { name: Order_By.Asc },
      ],
      where: {
        category: { _in: [...VALID_TAXONOMY_CATEGORIES] },
        is_archived: { _eq: false },
        is_leaf: { _eq: true },
        name: { _neq: 'All' },
      },
    },
  });

  const handleDownloading = useCallback(async () => {
    const { data: { segment = [] } = {} } = await fetchTaxonomy();
    csvDownload({
      data: prepareTaxonomyDataToDownload(segment),
      filename: 'OpenXSelect Segment Taxonomy - OpenX Confidential',
      headers: taxonomyHeaders,
    });
  }, [fetchTaxonomy]);

  return { handleDownloading, taxonomyLoading };
};
